import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

import Button from '../../../../../UniformComponents/Button'
import Modal from '../../../../../UniformComponents/Modal'

class SubmitModal extends Component {
    renderComplete = () => {
        const {
            status,
        } = this.props
        let content
        if (status !== 200 && status !== null) {
            content = (
                <div className="uc-modal__header">
                    <h2>{i18n.t('crossTab.modal.download.title.failure')}</h2>
                    <p className="uc-modal__desc">{i18n.t('crossTab.modal.download.desc.failure')}</p>
                </div>
            )
        } else {
            content = (
                <>
                    <div className="uc-modal__header">
                        <h2>{i18n.t('crossTab.modal.download.title.success')}</h2>
                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <i className="fa-solid fa-circle-check submit-modal-download-success-icon" />
                    </div>
                </>
            )
        }
        return content
    }

    renderContent = () => (
        <>
            <div className="uc-modal__header">
                <h2>{i18n.t('crossTab.modal.download.title.success')}</h2>
                <p className="uc-modal__desc">{i18n.t('crossTab.modal.download.desc.success')}</p>
            </div>
        </>
    )

    render() {
        const {
            response,
            status,
            loading,
            handleSubmitModal,
            modalStatus,
        } = this.props

        return (
            <Modal
                show={modalStatus}
                onClose={handleSubmitModal}
                dialogClassName="custom-modal"
            >
                <div id="submit-modal">
                    {loading ? this.renderContent() : this.renderComplete()}
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={handleSubmitModal}
                            cssClass="tertiary regular btn"
                        >
                            {i18n.t('close')}
                        </Button>
                        {!(status !== 200 && status !== null) && !loading && (
                            <a
                                href={response}
                                className="uc-button primary regular btn"
                                style={{ color: '#2B3C44' }}
                            >
                                <i className="fa-solid fa-folder-arrow-down" />
                                {' '}
                                {i18n.t('download')}
                            </a>
                        )}
                    </div>
                </div>
            </Modal>
        )
    }
}

/**
 * @param {boolean} modalStatus                         - indicating if modal is open or closed
 * @param {function} [handleSubmitModal]                - to update of modal status
 */

SubmitModal.propTypes = {
    modalStatus: PropTypes.bool.isRequired,
    handleSubmitModal: PropTypes.func,
}

export default SubmitModal
